import { render, staticRenderFns } from "./CoursesStorage.vue?vue&type=template&id=94cda1c6&scoped=true&"
import script from "./CoursesStorage.vue?vue&type=script&lang=js&"
export * from "./CoursesStorage.vue?vue&type=script&lang=js&"
import style0 from "./CoursesStorage.vue?vue&type=style&index=0&id=94cda1c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cda1c6",
  null
  
)

export default component.exports